import React, {memo, useEffect, useState} from "react";
import {LabelNumberTextControl} from "../index";

interface  LabelNumberTextProps {
    editor: any;
    value: string;
    putData: (data: number) => void;
    labelText: string;
    allowDecimal: boolean;
    inputDisabled: boolean;
}

const LabelNumberText = (props: LabelNumberTextProps) => {
    const [value, setValue] = useState(`${LabelNumberTextControl.DEFAULT_VALUE}`);

    const handleOnBlur = () => {
        if (value === "") setValue(`${LabelNumberTextControl.DEFAULT_VALUE}`);
        props.editor.trigger("process");
    }

    const handleOnChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setValue(event.target.value);

        let numberValue = event.target.value === ""
            ? LabelNumberTextControl.DEFAULT_VALUE
            : (props.allowDecimal ? parseFloat(event.target.value) : parseInt(event.target.value));
        props.putData(numberValue);
    }

    useEffect(() => {
        setValue(props.value);
    }, [props.value]);

    return (
        <div className="text-control">
            <div className="text-control-label">
                {props.labelText}
            </div>
            <input
                className="text-control-input"
                type="text"
                onInput={(e) => {
                    if (props.allowDecimal) {
                        e.currentTarget.value = e.currentTarget.value
                            .replace(/[^0-9.]/g, "")
                            .replace(/(\..*?)\..*/g, "$1")
                            .replace(/^0[^.]/, "0")
                    } else {
                        e.currentTarget.value = e.currentTarget.value
                            .replace(/[^0-9]/g, "")
                            .replace(/^0[^.]/, "0")
                    }
                }}
                value={value}
                disabled={props.inputDisabled}
                onPointerDown={e => e.stopPropagation()}
                onChange={handleOnChange}
                onBlur={handleOnBlur}/>
        </div>
    )
};

export default memo(LabelNumberText)